import { isYesterday, isToday } from 'date-fns';

interface IParsedDate {
  day: number;
  hours: number;
  minutes: number;
  month: number;
  seconds: number;
  year: number;
  timestamp: number;
}

interface IPrettyDateSettingsObject {
  showOnlyTime?: boolean;
  showFullDateWithTime?: boolean;
  showTime?: boolean;
}

const monthDict = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

interface IPrettyDateObject {
  day: number | string;
  hours: string | number;
  minutes: string | number;
  month: string;
  prettyDate: string | number;
  prettyTime: string;
  year: number | null;
}

export const parseDate = (date: Date): IParsedDate => {
  return {
    day: date.getDate(),
    hours: date.getHours(),
    minutes: date.getMinutes(),
    month: date.getMonth(),
    seconds: date.getSeconds(),
    timestamp: date.getTime(),
    year: date.getFullYear(),
  };
};

export const getDate = (parsedDate: IParsedDate): IPrettyDateObject => {
  const currentParsedDate = parseDate(new Date());

  const day = isToday(parsedDate.timestamp) ? 'Сегодня' : isYesterday(parsedDate.timestamp) ? 'Вчера' : parsedDate.day;
  const year = currentParsedDate.year > parsedDate.year ? parsedDate.year : null;
  const month = monthDict[parsedDate.month];
  const hours = parsedDate.hours.toString().padStart(2, '0');
  const minutes = parsedDate.minutes.toString().padStart(2, '0');

  const prettyDate = isNaN(day as number) ? day : `${day} ${month}${year ? ` ${year}` : ''}`;
  const prettyTime = `${hours}:${minutes}`;

  return {
    day,
    hours,
    minutes,
    month,
    prettyDate,
    prettyTime,
    year,
  };
};

export const getPrettyTimeString = (
  dateObject: IPrettyDateObject,
  {
    showOnlyTime,
    showTime,
    showFullDateWithTime,
  }: {
    showOnlyTime?: boolean;
    showFullDateWithTime?: boolean;
    showTime?: boolean;
  },
): string => {
  let prettyDate = showOnlyTime ? dateObject.prettyTime : dateObject.prettyDate;

  if (showTime && !showOnlyTime) {
    if (!dateObject.year) {
      prettyDate += `, ${dateObject.prettyTime}`;
    } else if (showFullDateWithTime) {
      prettyDate += `, ${dateObject.prettyTime}`;
    }
  }

  return prettyDate as string;
};

export const getPrettyChatDate = (
  date: number,
  { showOnlyTime, showTime, showFullDateWithTime }: IPrettyDateSettingsObject,
): string => {
  const convertDate = new Date(date);

  return convertDate && date
    ? getPrettyTimeString(getDate(parseDate(new Date(convertDate))), { showOnlyTime, showTime, showFullDateWithTime })
    : '';
};
